import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Services from '../../pages/Services/Services';
import Information from '../../pages/Info/Information';
import Feedback from '../../pages/Feedback/Feedback';
import Appointment from '../../pages/Appointment/Appointment';
import Doctors from '../../pages/Doctors/Doctors';
import Testimonials from '../../pages/Testimonials/Testimonials';
import Hero from '../../views/Hero';

const Home = () => {


  return (
    <>
      <Hero />
      <Services />
      <Information />
      <Doctors />
      <Feedback />
      <Testimonials />
      <Appointment />
    </>
  );
};

export default Home;

